<template>
    <div>
        <image-component :infoType="'banner'" :infoKey="`fatherBanner`"></image-component>
        <terms-component :terms-type="'stipulation'"></terms-component>
    </div>
</template>

<script>
// @ is an alias to /src
import ImageComponent from "@/components/information/ImageComponent";
import TermsComponent from "@/components/terms/TermsComponent";

export default {
    name: 'Term',
    mixins: [],
    components: {TermsComponent,ImageComponent},
    props: {},
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {

    },
    watch: {
    },
}
</script>
<style lang="scss">
.intro_tab {
    color: #9f9f9f;
    width: 25%;
    border-top: 1px solid;
    border-bottom: 1px solid;
    display: inline-block;
    text-align: center;
}

.intro_tab:first-child {
    border-left: 1px solid;
}

.intro_tab:last-child {
    border-right: 1px solid;
}
</style>
